import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from './apiClient';
import supplyOrderKeys from './useSupplyOrders';
import { externalOrderKeys } from './useExternalOrders';
import { invalidateMaterialReports } from './useMaterialReports';

/** Calcula saldos de compra para una selección explícita de pedidos. */
export const usePreviewConsolidatedSupplyOrder = () =>
  useMutation({
    mutationFn: async (payload) =>
      (await apiClient.post('supply_orders/from-external-orders/preview', payload)).data,
  });

/** Guarda borradores consolidados conservando las referencias de cada origen. */
export const useCreateConsolidatedSupplyOrder = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async (payload) =>
      (await apiClient.post('supply_orders/from-external-orders', payload)).data,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: supplyOrderKeys.all });
      client.invalidateQueries({ queryKey: externalOrderKeys.all });
      invalidateMaterialReports(client);
    },
  });
};
